import type { JSX } from 'react';
import { Footer } from '../Footer';
import { Nav } from '../Nav';

import styles from './Page.module.css';

/**
 * The full-height shell every route sits in: nav, content, footer.
 *
 * There is one route today. This exists so that the second one cannot accidentally ship without
 * the chrome, rather than because the site is large.
 */
export function Page({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <div className={styles.page}>
      <Nav />
      <main className={styles.main}>{children}</main>
      <Footer />
    </div>
  );
}
